export const EVENT_MAP = {
  'channel.created': true,
  'channel.deleted': true,
  'channel.hidden': true,
  'channel.kicked': true,
  'channel.muted': true,
  'channel.truncated': true,
  'channel.unmuted': true,
  'channel.updated': true,
  'channel.visible': true,
  'draft.deleted': true,
  'draft.updated': true,
  'health.check': true,
  'member.added': true,
  'member.removed': true,
  'member.updated': true,
  'message.deleted': true,
  'message.new': true,
  'message.read': true,
  'message.updated': true,
  'message.undeleted': true,
  'notification.added_to_channel': true,
  'notification.channel_deleted': true,
  'message.delivered': true,
  'notification.channel_mutes_updated': true,
  'notification.channel_truncated': true,
  'notification.invite_accepted': true,
  'notification.invite_rejected': true,
  'notification.invited': true,
  'notification.mark_read': true,
  'notification.mark_unread': true,
  'notification.message_new': true,
  'notification.mutes_updated': true,
  'notification.reminder_due': true,
  'notification.removed_from_channel': true,
  'notification.thread_message_new': true,
  'poll.closed': true,
  'poll.updated': true,
  'poll.vote_casted': true,
  'poll.vote_changed': true,
  'poll.vote_removed': true,
  'reaction.deleted': true,
  'reaction.new': true,
  'reaction.updated': true,
  'reminder.created': true,
  'reminder.deleted': true,
  'reminder.updated': true,
  'thread.updated': true,
  'typing.start': true,
  'typing.stop': true,
  'user.banned': true,
  'user.deleted': true,
  'user.messages.deleted': true,
  'user.presence.changed': true,
  'user.unbanned': true,
  'user.unread_message_reminder': true,
  'user.updated': true,
  'user.watching.start': true,
  'user.watching.stop': true,
  // AI events
  'ai_indicator.update': true,
  'ai_indicator.stop': true,
  'ai_indicator.clear': true,

  // local events
  'channels.queried': true,
  'offline_reactions.queried': true,
  'connection.changed': true,
  'connection.recovered': true,
  'transport.changed': true,
  'capabilities.changed': true,
  'live_location_sharing.started': true,
  'live_location_sharing.stopped': true,
};
